function applyMonthlyTheme() {
  const month = new Date().getMonth() + 1
  document.body.classList.remove('outubro-rosa', 'novembro-azul')

  if (month === 10) {
    document.body.classList.add('outubro-rosa')
  } else if (month === 11) {
    document.body.classList.add('novembro-azul')
  }

  const isDev =
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('dev') ||
    window.location.hostname.includes('hml')

  if (isDev) {
    window.forcarOutubro = () => {
      document.body.classList.remove('outubro-rosa', 'novembro-azul')
      document.body.classList.add('outubro-rosa')
    }
    window.forcarNovembro = () => {
      document.body.classList.remove('outubro-rosa', 'novembro-azul')
      document.body.classList.add('novembro-azul')
    }
    window.voltarAutomatico = () => applyMonthlyTheme()
  }
}

applyMonthlyTheme()
export { applyMonthlyTheme }
